import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './sideMenu.css';
import logoBlanco from '../../../assets/img/LOGO-BLANCO-SIN-BAJADA.png';
import bicepsSvg from '../../../assets/img/biceps.svg';
import { getUserInfo } from './sideMenuController';
import { fetchTraining } from './sideMenuController';
import { GetExtraUrls } from './sideMenuController';

export const SideMenu = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const [memberStatus, setMerberStatus] = useState(null)
  const [urlService, setUrlService] = useState(null)
  const [extraUrls, setExtraUrls] = useState(null)

  //? sino existe en localStorage TPATrainingStatus setearlo
  const [refresh, setRefresh] = useState(false)

  const handleRefresh = () => {
    setRefresh(!refresh)
    //console.log('refresh')
  };

  useEffect(() => {

    //console.log('se ejecuta de nuevo')


    const setingUrl = async () => {

      const info = await getUserInfo()

      //console.log('infoSideMenu: ', info)

      if (info && info.data.subscriptions) {

        //console.log('info.data.subscriptions', info.data.subscriptions)
        localStorage.setItem('TPATrainingStatus', info.data.subscriptions.TPATraining)
        setMerberStatus(info.data.subscriptions.TPATraining)


      }
      
      const TPAmemberStatus = await fetchTraining()

      if (TPAmemberStatus) {
        //console.log('TPAmemberStatus', TPAmemberStatus.data.data.urlService)
        setUrlService(TPAmemberStatus.data.data.urlService)
        setMerberStatus(localStorage.getItem('TPATrainingStatus'))
      }

    }   

    setingUrl()

    const getExtraUrl = async () => {
      const responseExtraUrls = await GetExtraUrls()

      setExtraUrls(responseExtraUrls);
    }

    getExtraUrl();    

  }, [refresh, navigate])



  return (
    <div className='col-md-2 d-none d-md-flex menu'>
      <img className="menu-logo" src={logoBlanco} alt="logo" />
      <span className='span-sala-virtual'>Sala Virtual</span>
      <ul className="menu-list">


        <li className={`li-menu ${location.pathname === '/biblioteca' || location.pathname.startsWith('/videos') ? 'li-menu-selected' : ''}`}>
          <Link className="a-profession" to="/biblioteca">
            <span className="material-symbols-outlined responsive-size-icon">smart_display</span>
            <p className="p-profession d-none d-md-block">TPA® Biblioteca</p>
          </Link>
        </li>

        <li className={`li-menu ${location.pathname === '/training' ? 'li-menu-selected' : ''}`}>
  
         <Link
            className="a-management"
            to={`${memberStatus === 'Approved' ? `${urlService}` : '/training'} `}
            target={memberStatus === 'Approved' ? '_blank' : '_self'}
            onClick={() => handleRefresh()}
          >
            <img className="bicepsSvg responsive-size-icon-img" src={bicepsSvg} alt="" />
            <p className="p-management d-none d-md-block">TPA® Training</p>
          </Link>
        </li>

        {/* Extra URLS traidas de RestAPI */}
        {extraUrls && extraUrls.length > 0 ? extraUrls.map((l) => (          
          <li key={l.id} className={`li-menu ${l.isInternal && location.pathname === `/avisos/${l.id}` ? 'li-menu-selected' : ''}`}>
          <Link
            className="a-management"
            to={ l.isInternal ? `/avisos/${l.id}` : l.url }
            target={l.isInternal ? '_self' : '_blank'}
          >
            <span className="material-symbols-outlined responsive-size-icon">{l.icon}</span>
            <p className="p-management d-none d-md-block">{l.title}</p>
          </Link>
        </li>

        )) : null }
        

      </ul>
    </div>
  );
};
